const messages = {
  name: 'Credit Transaction |||| Credit Transactions',
  fields: {
    account: 'Account',
    costCenterName: 'Cost Center',
    transactionType: 'Type',
    amount: 'Amount',
    balanceAfter: 'Balance After',
    createdAt: 'Created At',
    createdByUserName: 'Created By',
  },
  empty: 'No credit transactions yet',
  actions: {
    exportCsv: 'CSV',
    exportPdf: 'PDF',
  },
  filters: {
    account: 'Account',
    costCenterName: 'Cost Center',
    transactionType: 'Transaction Type',
  },
  search: {
    placeholder: 'Search Credit Transactions',
  },
};

export default messages;
